export default "__VITE_ASSET__fcd55b70__"